import type { CollaborateUserRef, Thread } from "../types/collaborateThread";

/** Unique participants on a thread (author + reply authors). */
export function threadParticipants(thread: Thread): CollaborateUserRef[] {
  const seen = new Set<string>();
  const out: CollaborateUserRef[] = [];
  const add = (user: CollaborateUserRef) => {
    if (!seen.has(user.id)) {
      seen.add(user.id);
      out.push(user);
    }
  };
  add(thread.createdBy);
  thread.replies.forEach((r) => add(r.createdBy));
  return out;
}
